// ============================================================================
//  Programa: MPEL
//  Encuesta: "fin" (form 5179963).
//  Muy parecido a EOP: mismo bloque de datos + campo en cascada
//  Departamento → Localidad (reusa eopLocalidades.js, es el mismo dataset).
//  Diferencias con EOP:
//    - Agrega "Barrio de residencia" (tfa_4516, texto).
//    - Las dos preguntas abiertas cambian (lo que menos / lo que más gustó).
// ============================================================================
import EOP_LOCALIDADES from "./eopLocalidades";
import { validarCedula, validarEmail, validarFecha } from "./validaciones";

// tfa_4675 NO va por defecto: se pasa por la URL (?tfa_4675=...), igual que en EOP.
const DEFAULTS_MPEL = {};

const NOTA_1_10 = (base) =>
  Array.from({ length: 10 }, (_, i) => ({
    val: `tfa_${base + (9 - i)}`,
    label: String(10 - i),
  }));
const STEPS_MPEL = [
  { id: "tfa_1877", label: "¡Hola! Para empezar, ¿cuál es tu nombre?", type: "text", placeholder: "Tu nombre" },
  { id: "tfa_1875", label: "¿Y tu apellido?", type: "text", placeholder: "Tu apellido" },
  { id: "tfa_1", label: "¿Cuál es tu cédula de identidad?", type: "text", placeholder: "Tu número de documento", validate: validarCedula },
  { id: "tfa_1879", label: "¿Con qué género te identificás?", type: "radio", options: [
    { val: "tfa_1966", label: "Masculino" },
    { val: "tfa_1967", label: "Femenino" },
    { val: "tfa_1968", label: "No binario" },
  ]},
  { id: "tfa_1881", label: "¿Cuál es tu fecha de nacimiento? (DD/MM/AAAA)", type: "text", placeholder: "Ej: 15/06/2001", validate: validarFecha },
  { id: "tfa_3", label: "¿Cuál es tu correo electrónico personal?", type: "text", placeholder: "tu@email.com", validate: validarEmail },
  { id: "tfa_1885", label: "¿Cuál es tu número de celular?", type: "text", placeholder: "Ej: 099123456" },

  // Campo en cascada: departamento -> localidad
  {
    id: "tfa_1998", // departamento (campo principal)
    label: "¿En qué departamento vivís?",
    type: "cascade",
    cascade: EOP_LOCALIDADES,
    childLabel: "¿Y en qué localidad?",
  },

  { id: "tfa_4516", label: "¿En qué barrio vivís?", type: "text", placeholder: "Tu barrio" },

  { id: "tfa_4680", label: "Siendo 1 muy poco satisfactorio y 10 muy satisfactorio, ¿cómo evaluarías a la tallerista?", type: "radio", options: NOTA_1_10(4681) },
  { id: "tfa_4702", label: "Siendo 1 muy poco satisfactorio y 10 muy satisfactorio, ¿qué te parecieron los contenidos trabajados en los talleres?", type: "radio", options: NOTA_1_10(4703) },
  { id: "tfa_4736", label: "¿Cuánto recomendarías el programa a un amigo? Siendo 1 no recomiendo y 10 recomiendo totalmente.", type: "radio", options: NOTA_1_10(4737) },

  { id: "tfa_4724", label: "¿Qué fue lo que menos te gustó del taller?", type: "text", placeholder: "Contanos con tus palabras..." },
  { id: "tfa_4748", label: "¿Qué fue lo que más te gustó del taller?", type: "text", placeholder: "Contanos con tus palabras..." },
];

const mpel = {
  label: "MPEL",
  tipoPorDefecto: "fin",
  tipos: {
    fin: {
      formId: "5179963",
      titulo: "Evaluación",
      subtitulo: "Encuesta de fin de programa",
      saludo: "¡Hola! Voy a ayudarte a completar la encuesta de fin de programa. ¡Empecemos!",
      cierre: "¡Perfecto! Respondiste todas las preguntas.",
      exito: "Gracias por completar la encuesta y por haber participado del programa. ¡Felicitaciones!",
      defaults: DEFAULTS_MPEL,
      steps: STEPS_MPEL,
    },
  },
};

export default mpel;